import submit from "submit-form";

export const validateWidget = (widget, edit = false, assert, flash) => {
  try {
    const { icon, type } = widget;

    const name = widget.name.trim();
    const description = widget.description.trim();

    assert(name, 400, "Widget name is required");
    assert(description, 400, "Widget description is required");
    assert(icon, 400, "Widget icon is required");
    if (!edit) {
      assert(type, 400, "Widget type is required");
    }

    const body = {
      name,
      description,
      icon,
      type,
    };

    if (edit) delete body.type;

    return body;
  } catch (err) {
    flash("error", err.message);
    submit("/actions/refresh");
    return false;
  }
};

/**
 * Order the array according to the order property
 * @param {*} arrayItemA
 * @param {*} arrayItemB
 * @returns
 */

const orderItemsByOrderProperty = (arrayItemA, arrayItemB) => {
  if (arrayItemA.order < arrayItemB.order || arrayItemB.order === undefined) {
    return -1;
  }

  if (arrayItemA.order > arrayItemB.order || arrayItemA.order === undefined) {
    return 1;
  }

  return 0;
};

/**
 * Order the widgets if they have or no the order property
 * @param {*} widgets
 * @returns
 */
export const orderWidgets = (widgets) => {
  const widgetsWithOrderProperty = widgets
    .filter((element) => element.hasOwnProperty("order"))
    .sort(orderItemsByOrderProperty);

  const widgetsWithoutOrderProperty = widgets.filter(
    (element) => !element.hasOwnProperty("order")
  );

  const orderedWidgets = [
    ...widgetsWithOrderProperty,
    ...widgetsWithoutOrderProperty,
  ];

  return orderedWidgets;
};

/**
 * Remove query params from a url
 * @param {*} url
 * @returns
 */
export const removeQueryParams = (url) => {
  const urlObj = new URL(url);
  urlObj.search = "";
  return urlObj.toString();
};

/**
 * Delete a widget
 * @param {*} e
 * @param {*} id
 */
export const deleteWidgetUtil = (e, id) => {
  if (
    process.browser &&
    confirm("Are you sure you want to delete this widget?")
  ) {
    e.stopPropagation();
    e.preventDefault();
    submit(`/actions/widgets/delete/${id}`, {
      method: "POST",
    });
  }
};
